// 고레벨 EXP 보정 표식 모델(C10-4): HUD 경험치 바 곁 표식과 레벨업 띠 한 줄의 문구를 만든다. DOM·게임 상태에 의존하지 않는 순수 함수.
// 규칙의 정본은 shared/growth.ts levelBandXpMult(Lv50 ×1 → Lv65 ×0.52)와 docs/PROGRESSION-720H.md 14절.
import { XP_BAND, levelBandXpMult } from '../shared/growth';

/** 표식 설명(탭·툴팁). 숫자는 XP_BAND에서 읽어 규칙이 바뀌면 같이 바뀐다 */
export const XP_BAND_HELP =
  `Lv${XP_BAND.from}부터 레벨이 오를수록 사냥 EXP가 줄어요(최저 ×${XP_BAND.mult.toFixed(2)}). 환생하면 다시 ×1`;

/** 설명을 보이기 시작하는 레벨: 감소 시작(Lv50) 5레벨 전. 그 전에는 신규에게 이른 정보라 빈 글자 */
export const XP_BAND_HELP_FROM = XP_BAND.from - 5;

/** 레벨에 맞는 표식 설명. Lv45 미만·NaN이면 빈 글자(화면·툴팁 모두 숨김) */
export function xpBandHelpText(level: number): string {
  return level >= XP_BAND_HELP_FROM ? XP_BAND_HELP : '';
}

/** 소수 둘째 자리 배율 글자 */
export function bandMultLabel(mult: number): string {
  return '×' + mult.toFixed(2);
}

/** 표식 글자: 배율이 1(보정 없음)이면 빈 글자 = 표식 숨김 */
export function xpBandBadgeText(level: number): string {
  const m = levelBandXpMult(level);
  return m < 1 ? '고레벨 보정 EXP ' + bandMultLabel(m) : '';
}

/**
 * 레벨업 띠 한 줄: 이번 레벨업으로 배율이 바뀌었을 때만 'EXP 보정 ×0.xx'. 안 바뀌면 빈 글자.
 * steps는 한 번에 오른 레벨 수(여럿 올라도 오른 뒤 레벨 기준으로 한 줄).
 */
export function xpBandLevelUpNote(level: number, steps: number): string {
  const to = levelBandXpMult(level);
  const from = levelBandXpMult(level - Math.max(1, steps));
  if (to >= 1 || bandMultLabel(to) === bandMultLabel(from)) return '';
  return 'EXP 보정 ' + bandMultLabel(to);
}
